export default __webpack_public_path__ + "static/media/ht.663996cf.svg";